type Labelled = { label?: string; name?: string | null };

const text = (o: Labelled) => o.label ?? o.name ?? '';

/** One place to render an audience expression as "(A OR B) AND (C) EXCLUDE X". Works for
 *  control-options (`label`) and IAudienceMeta (`name`). */
export const formatAudienceExpression = (include: Labelled[][] = [], exclude: Labelled[] = []): string => {
  const includePart = (include ?? [])
    .filter(group => group.length)
    .map(group => `(${group.map(text).join(' OR ')})`)
    .join(' AND ');
  const excludePart = (exclude ?? []).map(text).join(' OR ');
  if (!includePart) {
    return excludePart ? `EXCLUDE ${excludePart}` : '';
  }
  return excludePart ? `${includePart} EXCLUDE ${excludePart}` : includePart;
};
